// Bundled with esbuild via jsbundling-rails
// Disable Turbo Drive (SPA-like navigation/form interception).
// The app relies on jQuery AJAX, format.js responses and full page loads.
import { Turbo } from "@hotwired/turbo-rails";
Turbo.session.drive = false;
// rails-ujs handles data-method (DELETE/POST links) and data-confirm dialogs
import Rails from '@rails/ujs';
Rails.start();
import './channels';
import './lib/jquery';
import 'bootstrap';
import toastr from 'toastr';
window.toastr = toastr;
import '@fortawesome/fontawesome-free/js/all';

// TODO: All the following should not be here. Please DO NOT ADD MORE; rather, scope them out.
//       Also, remove the confusing and unconventionnal `application` namespace when you can.
import './application/datePicker';
import './application/funds';

import './application/users/contacts';
import './application/users/profiles';
import './application/users/show_or_hide_password';

import './application/users/profiles/legal/banking_step';
import './application/users/profiles/legal/beneficial_ownership_step';
import './application/users/profiles/legal/beneficiaries_step';
import './application/users/profiles/legal/categorization_step';
import './application/users/profiles/legal/client_id_step';
import './application/users/profiles/legal/commitments_step';
import './application/users/profiles/legal/company_type_step';
import './application/users/profiles/legal/documents_step';
import './application/users/profiles/legal/fatca_step';
// those pages are stil not working properly, with an error Cannot set properties of undefined (setting 'AutoNumeric')
import './application/users/profiles/legal/non_professional_investor_experience_step';
import './application/users/profiles/legal/non_professional_risk_comprehension_step';
import './application/users/profiles/legal/non_professional_supplemental_step';
import './application/users/profiles/legal/risks_step';

import './application/users/profiles/natural/banking_step';
import './application/users/profiles/natural/categorization_step';
import './application/users/profiles/natural/client_id_step';
import './application/users/profiles/natural/commitments_step';
import './application/users/profiles/natural/documents_step';
import './application/users/profiles/natural/fatca_step';
import './application/users/profiles/natural/financial_situation_step';
import './application/users/profiles/natural/non_professional_investor_experience_step';
import './application/users/profiles/natural/non_professional_risk_comprehension_step';
import './application/users/profiles/natural/non_professional_supplemental_step';
import './application/users/profiles/natural/risks_step';

import './application/users/subscriptions/details_step';
import './application/users/subscriptions/signature_step';

import './application/distributors/users';
import './application/datatables/documents';

// Page-specific modules (auto-initialize based on DOM elements)
import './funds/show';
import './users/performance_indicators/funds/index_view';
import './users/performance_indicators/funds/show';

toastr.options.toastClass = 'toastr';

function initApp() {
  if ($('.flash.info')[0]) {
    toastr['info']($('.flash.info').html());
  }
  if ($('.flash.notice')[0]) {
    toastr['info']($('.flash.notice').html());
  }
  if ($('.flash.success')[0]) {
    toastr['success']($('.flash.success').html());
  }
  if ($('.flash.error')[0]) {
    toastr['error']($('.flash.error').html());
  }
  if ($('.flash.alert')[0]) {
    toastr['error']($('.flash.alert').html());
  }

}

$(() => {
  initApp();

  $('body').on('change', '.custom-file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this)
        .siblings('.custom-file-label')
        .html($(this)[0].files[0].name);
    }
  });
});
